import React, {
  createContext,
  Dispatch,
  SetStateAction,
  useState,
} from "react";

interface CreateResult {
  codes: Array<string>;
  id: string;
}

interface CodesContextProps {
  name: string;
  setName: (name: string) => void;
  amount: number;
  setAmount: (amount: number) => void;
  loadingCreate: Boolean;
  setLoadingCreate: Dispatch<SetStateAction<boolean>>;
  createResult: CreateResult;
  setCreateResult: (result: CreateResult) => void;
  loadingDownload: Boolean;
  setLoadingDownload: Dispatch<SetStateAction<boolean>>;
}

export const CodesContext = createContext<CodesContextProps>(null);

const CodesContextProvider = (props) => {
  const [amount, setAmount] = useState(1);
  const [createResult, setCreateResult] = useState(null);
  // Basically only used to support the name field from being remembered when users presses "back" on modal for entering session name
  // Yes it's a horrible solution
  const [name, setName] = useState("");
  const [loadingCreate, setLoadingCreate] = useState(false);
  const [loadingDownload, setLoadingDownload] = useState(false);
  return (
    <CodesContext.Provider
      value={{
        name,
        setName,
        amount,
        setAmount,
        loadingCreate,
        setLoadingCreate,
        createResult,
        setCreateResult,
        loadingDownload,
        setLoadingDownload,
      }}
    >
      {props.children}
    </CodesContext.Provider>
  );
};
export default CodesContextProvider;
